import React from "react";
import { Link, useLocation } from "react-router-dom";
import { translations } from "../translations";

const Footer = () => {
  const location = useLocation();
  const currentLang = location.pathname.split("/")[1] || "fr";
  const t = translations[currentLang];

  return (
    <footer className="bg-accent text-white py-8 mt-12 rounded-lg text-center">
      <div className="container mx-auto px-4 flex flex-col items-center gap-4 sm:flex-row sm:justify-between">

        {/* Left: Copyright */}
        <p className="text-sm sm:text-base">&copy; 2025 KIM ANH Projects. All rights reserved.</p>

        {/* Middle: Links */}
        <div className="flex gap-6 text-sm sm:text-base">
          <Link to={`/${currentLang}/legal-notices`} className="hover:text-primary transition">
            {t.mentions}
          </Link>
          <Link to={`/${currentLang}/privacy-policy`} className="hover:text-primary transition">
            {t.politique}
          </Link>
        </div>
      </div>

      {/* Separator */}
      <div className="border-t border-gray-500 my-4 w-3/4 mx-auto" />

      {/* Signature */}
      <div className="text-sm text-gray-300">
        {t.pcw}{" "}
        <a
          href="https://pointcommun-web.fr"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary"
        >
          Point Commun Web
        </a>
      </div>
    </footer>
  );
};

export default Footer;
